import type { AuthSession, SessionStorage } from '@logistech/ui-shared';

const KEY = 'logistech.session';

export const sessionStorage: SessionStorage = {
  get(): AuthSession | null {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? (JSON.parse(raw) as AuthSession) : null;
    } catch {
      return null;
    }
  },
  set(s) {
    localStorage.setItem(KEY, JSON.stringify(s));
  },
  clear() {
    localStorage.removeItem(KEY);
  },
};
